import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import { Button } from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';

import config from '@plone/volto/registry';
import { BlocksForm } from '@plone/volto/components/manage/Form';
import EditBlockWrapper from '@plone/volto/components/manage/Blocks/Container/EditBlockWrapper';

const ALLOWED_BLOCKS = ['csjCard'];

const getNestedBlocksConfig = () =>
  pick(config.blocks.blocksConfig, ALLOWED_BLOCKS);

const IconCardGridBlocksEditor = ({
  data,
  block,
  onChangeBlock,
  pathname,
  selected,
  manage,
  metadata,
  properties,
  gridSelected,
  setGridSelected,
  defaultVariant = 'stacked',
}) => {
  const blocks = data.blocks || {};
  const blocksLayout = data.blocks_layout || { items: [] };
  const blocksConfig = getNestedBlocksConfig();
  const selectedBlockInGrid = blocksLayout.items.includes(gridSelected)
    ? gridSelected
    : null;

  const onAddBlock = () => {
    const newBlockId = uuid();
    onChangeBlock(block, {
      ...data,
      blocks: {
        ...blocks,
        [newBlockId]: {
          '@type': 'csjCard',
          variant: defaultVariant,
        },
      },
      blocks_layout: {
        items: [...blocksLayout.items, newBlockId],
      },
    });
    setGridSelected(newBlockId);
  };

  return (
    <div className="icon-card-grid-editor">
      <div className="icon-card-grid-editor-header">
        <span>Graella icones</span>
        {selected ? (
          <Button compact size="mini" type="button" onClick={onAddBlock}>
            + Element
          </Button>
        ) : null}
      </div>
      <div
        className="icon-card-grid-editor-blocks"
        role="presentation"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <BlocksForm
          metadata={metadata || properties}
          properties={{
            blocks,
            blocks_layout: blocksLayout,
          }}
          direction="vertical"
          manage={manage}
          selectedBlock={selected ? selectedBlockInGrid : null}
          blocksConfig={blocksConfig}
          isContainer
          isMainForm={false}
          disableAddBlockOnEnterKey
          onSelectBlock={(id) => {
            setGridSelected(id);
          }}
          onChangeFormData={(newFormData) => {
            onChangeBlock(block, {
              ...data,
              blocks: newFormData.blocks,
              blocks_layout: newFormData.blocks_layout,
            });
          }}
          onChangeField={(id, value) => {
            if (id === 'blocks' || id === 'blocks_layout') {
              onChangeBlock(block, {
                ...data,
                blocks: id === 'blocks' ? value : blocks,
                blocks_layout: id === 'blocks_layout' ? value : blocksLayout,
              });
            }
          }}
          pathname={pathname}
        >
          {({ draginfo }, editBlock, blockProps) => (
            <EditBlockWrapper draginfo={draginfo} blockProps={blockProps}>
              {editBlock}
            </EditBlockWrapper>
          )}
        </BlocksForm>
      </div>
    </div>
  );
};

IconCardGridBlocksEditor.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  manage: PropTypes.bool.isRequired,
  metadata: PropTypes.objectOf(PropTypes.any),
  properties: PropTypes.objectOf(PropTypes.any),
  gridSelected: PropTypes.string,
  setGridSelected: PropTypes.func.isRequired,
  defaultVariant: PropTypes.string,
};

export default IconCardGridBlocksEditor;
